export const matchKickoffTime = (match) => {
  if (!match?.date) return null;
  const date = String(match.date).slice(0, 10);
  const time = match.time ? String(match.time).slice(0, 8) : '23:59:59';
  const parsed = new Date(`${date}T${time}`);
  return Number.isNaN(parsed.getTime()) ? null : parsed.getTime();
};

export const sortMatchesNextFirst = (matches = [], now = new Date()) => {
  const nowMs = now.getTime();

  const classify = (match) => {
    const kickoff = matchKickoffTime(match);
    const status = String(match?.status || '').toLowerCase();

    if (status === 'live') return { group: 0, time: kickoff ?? nowMs };

    const isCompleted = status === 'completed' || status === 'canceled';
    const isFuture = kickoff !== null && kickoff >= nowMs;

    if (!isCompleted && isFuture) return { group: 1, time: kickoff };
    if (!isCompleted && kickoff === null) return { group: 2, time: Number.MAX_SAFE_INTEGER };

    return { group: 3, time: kickoff ?? 0 };
  };

  return [...(matches || [])].sort((a, b) => {
    const aMeta = classify(a);
    const bMeta = classify(b);

    if (aMeta.group !== bMeta.group) return aMeta.group - bMeta.group;

    // LIVE / upcoming / unscheduled: nearest first.
    if (aMeta.group < 3) return aMeta.time - bMeta.time;

    // Completed / past: most recent first.
    return bMeta.time - aMeta.time;
  });
};
